/* Program Name: DomainContext.js
 **  Description: a component that handles the state of the theme for the
 **               entire application
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-04-12  STT  Initial program
 *********************************************************************************/

/**React imports */
import React, { useContext, createContext, useState, useEffect } from 'react'

//Creates the AlertContext using reacts context //DOCS: https://reactjs.org/docs/context.html
const DomainContext = createContext()

//Creates the hook to access the state of the AlertContext //DOCS: https://reactjs.org/docs/hooks-custom.html
export function useDomain() {
  return useContext(DomainContext)
}

/**Constructor for the AlertProvider component */
//children > props that passes the components through it like a wrapper
export default function DomainProvider({ children }) {
  /*********************************************************************************************** */
  /**Local Variables */

  //alert holds the status of the alerts 'success' and 'fail'
  //false = closed, true = open
  const [currentDomain, setCurrentDomain] = useState(null)
  const [strippedDomain, setStrippedDomain] = useState(null)

  //value is the object that is passed into the Provider which allows anything in the value to be access
  //by the children of AlertProvider
  const value = {
    currentDomain,
    setCurrentDomain,
    strippedDomain,
  }

  useEffect(() => {
    const URI = /:\/\/([^/]+)/.exec(window.location.href)
    const subDomain = URI[1].split('.')[0]
    const stripped = subDomain.split('-')[0]
    setCurrentDomain(subDomain)
    setStrippedDomain(stripped)
  }, [])

  /*********************************************************************************************** */
  /**Rendering */

  return (
    <DomainContext.Provider value={value}>{children}</DomainContext.Provider>
  )
}
